window.REGISTRO_SALVO_COM_SUCESSO = { type: 'success', msg: 'Registro salvo com sucesso.' };
window.REGISTRO_EXCLUIDO_COM_SUCESSO = { type: 'success', msg: 'Registro excluído com sucesso.' };

window.FALHA_AO_SALVAR_REGISTRO = { type: 'danger', msg: 'Falha ao salvar registro. Tente novamente mais tarde.' };
window.FALHA_AO_EXCLUIR_REGISTRO = { type: 'danger', msg: 'Falha ao excluir registro. Tente novamente mais tarde.' };
window.FALHA_AO_CONSULTAR_REGISTRO = { type: 'danger', msg: 'Falha ao consultar registro. Tente novamente mais tarde.' };

window.ACESSO_NAO_PERMITIDO = { type: 'danger', msg: 'Acesso não permitido.' };

window.REGISTRO_NAO_EXISTE = { type: 'warning', msg: 'Registro não existe.' };